// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.N6OdHnTk3zCiXN {
  margin-bottom: var(--ds-space-250, 19px);
  font-size: 24px;
  font-weight: var(--ds-font-weight-medium, 500);
  text-align: center;
}
.pYRpR6OTat8Yi3 {
  margin-bottom: var(--ds-space-150, 12px);
  text-align: center;
}
.qxiGJngZHfmO8E {
  width: 750px;
  margin-bottom: var(--ds-space-150, 12px);
  text-align: center;
}
@media only screen and (max-width: 750px) {
  .N6OdHnTk3zCiXN {
    font-size: 20px;
  }
  .pYRpR6OTat8Yi3 {
    width: 320px;
  }
}
.GattVphvAYJ9Up {
  display: flex;
  flex-direction: column;
  align-items: center;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `N6OdHnTk3zCiXN`,
	"trelloDesc": `pYRpR6OTat8Yi3`,
	"ppDesc": `qxiGJngZHfmO8E`,
	"upgradeView": `GattVphvAYJ9Up`
};
export default ___CSS_LOADER_EXPORT___;
